import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

function RequireProfile() {
  const { user, loading } = useAuth()

  if (loading) {
    return null
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (user.profileLevel < 3) {
    return <Navigate to="/onboarding" replace />
  }

  return <Outlet />
}

export default RequireProfile
